export default "__VITE_ASSET__OR4DArnf__"